angular
	.module 'App.Repository'

.factory 'DeviceRepository', ['BaseRepository', (BaseRepository) ->
		class DeviceRepository extends BaseRepository
			@resource = '/devices'
			@isRestricted = true

		return new DeviceRepository
	]
